import { render, staticRenderFns } from "./clientslogs.vue?vue&type=template&id=6d0e9b85&scoped=true"
import script from "./clientslogs.vue?vue&type=script&lang=js"
export * from "./clientslogs.vue?vue&type=script&lang=js"
import style0 from "./clientslogs.vue?vue&type=style&index=0&id=6d0e9b85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0e9b85",
  null
  
)

export default component.exports